import {SocialLink} from '../../types/api';
import socials from '../../lib/socials';
import {Icon, IconButton} from '@mui/material';
import {addSourceTracker, TrackingSource} from '../../lib/tracking';
import {PreviewProfileProps} from './types.ts';
import {logError} from '../../sentry.ts';

type Props = {} & SocialLink & PreviewProfileProps;

export default function SocialCard({
    value,
    trackingUrl,
    type,
    isPreview,
}: Props) {
    const social = socials[type];
    if (!social) {
        logError(new Error(`Unsupported social type: ${type}`));
        return null;
    }

    return (
        <IconButton
            title={social.name}
            href={
                isPreview
                    ? value
                    : trackingUrl
                      ? addSourceTracker(trackingUrl, TrackingSource.Profile)
                      : value
            }
            target={'_blank'}
            rel={'noopener'}
        >
            <Icon
                sx={{
                    fontSize: {
                        xs: 35,
                        md: 40,
                    },
                }}
                component={social.image}
            />
        </IconButton>
    );
}
